// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"aa382e0c","247":"d6cbea8f","422":"c33165eb","627":"90d56423","768":"6c10e945","806":"5ed884df","834":"5e098367","923":"8c5b67dc","938":"b27e57ee"}[chunkId] + ".chunk.js";
};